import { createGlobalStyle } from "styled-components"

const GlobalStyles = createGlobalStyle`

:root {

  --beige: color(display-p3 0.964706 0.929412 0.831373 / 1.000000);
  --red: color(display-p3 0.850980 0.019608 0.121569 / 1.000000);
  --yellow: color(display-p3 0.996078 0.756863 0.168627 / 1.000000);
  --black color(display-p3 0.698039 0.168627 0.168627 / 1.000000);

  @font-face {
    font-family: "DB Heavent";
    src: url("/fonts/DBHeavent.woff") format('woff');
  }
  
    @media (min-width: 768px) {
      --h1: 2.6rem;
      --h2: 2.4rem;
      --h3: 1.75rem;
      --h4: 1.5rem;
      --h5: 1.25rem;
      --h6: 1.1rem;
      --footerMenuItem: 1rem;
      --para: 1.1rem;
      --spacing: 0.8rem;
    }

    @media (min-width: 1200px) {
      --h1: 3rem;
      --h2: 2.8rem;
      --h3: 2rem;
      --h4: 1.75rem;
      --h5: 1.35rem;
      --para: 1.15rem;
      --spacing: 0.8rem;
    }
  }

* {
    box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: "DB Heavent";
    color: #fff;
    background: var(--beige);
}


  .content-container {
    margin: 0 auto;
    width: 100%;
    max-width: 500px;
    text-align: center;
    -webkit-box-pack: center;
    justify-content: center;

    @media (min-width: 1080px) {
      max-width: 650px;
    }
  }

  .flex-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-evenly; 
    align-items: center; 
    padding: 0 10px;

    @media (min-width: 900px) {
      padding: 0 50px;
    }

    &.duo-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
  
      @media (min-width: 900px) {
        flex-direction: row;
        width: 100%;
        height: 100%;
      }
    }
  
  }

  

  .mt-1 {
    margin-top: 1.25rem !important;
  }

  .section-padding {
    padding: 100px 30px;
  }

  .text-center {
    text-align: center;
  }

  .sr-only {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important; /* 1 */
    -webkit-clip-path: inset(60%) !important;
    clip-path: inset(60%) !important; /* 2 */
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
    white-space: nowrap !important; /* 3 */
  }

  .sr-only-focusable:focus,
  .sr-only-focusable:active {
    clip: auto !important;
    -webkit-clip-path: none !important;
    clip-path: none !important;
    height: auto !important;
    margin: auto !important;
    overflow: visible !important;
    width: auto !important;
    white-space: normal !important;
  }
`
export default GlobalStyles
